import { CCTVHISTORIS } from "../../actions/dashboard";

export default function(state = [], action) {
  switch (action.type) {
    case CCTVHISTORIS:
      return action.payload;
    default:
  }
  return state;
}
